export * from './directive/lyrics-editor-trigger.directive';
export * from './editor/lyrics-editor.component';
export * from './timestamp-lyrics.pipe';
